export default function(Vuex) {
  return new Vuex.Store({
    state: {
      user: null,
      parts: [],
      drawer: null,
      appData: {},
      authState: "authState",
      isGuestMode: false,
      windowWidth: null,
      isProduction: true,
      userIsInternal: false,
      booksCategories: {},
      authenticatedUser: "authenticatedUser",
    },
    mutations: {
      toggleDrawer(state) {
        state.drawer = !state.drawer;
      },
      setParts(state, parts) {
        state.parts = parts;
      },
      setBooksCategories(state, categories) {
        state.booksCategories = categories;
      },
      setWindowWidth(state, size) {
        state.windowWidth = size;
      },
      setAppData(state, appData) {
        state.user = appData.userData;
        state.appData = appData;
        state.isProduction = appData.envData.isProduction;
        state.user.internal = appData.userData.groups.includes("Internal");
      },
      setAuthState(state, authState) {
        state.authState = authState;
      },
      setUser(state, user) {
        state.user = user;
      },
      setCurrAuthUser(state, authData) {
        state.authenticatedUser = authData;
      },
      setGuestMode(state, isGuestMode) {
        state.isGuestMode = isGuestMode;
      },
    },
  });
}
